<template>
  <div>
    <FollowsInfoDialog ref="FollowsInfoDialog"></FollowsInfoDialog>
    <v-row>
      <v-col md="8">
        <div class="pb-5 d-flex">
          <span class="display-1 pt-1 font-weight-bold" v-if="!isFollower">Follows</span>
          <span class="display-1 pt-1 font-weight-bold" v-if="isFollower">Following</span>
          <span>
            <v-btn :title="$t('follows.general.Click to see more information')" @click.stop="$refs.FollowsInfoDialog.openDialog()" icon large>
              <v-icon color="primary">far fa-question-circle</v-icon>
            </v-btn>
          </span>
        </div>
        <v-row v-if="!isFollower">
          <v-col md="6" v-for="item in following" :key="item.id">
            <v-card class="mx-auto" max-width="344" outlined>
              <v-list-item three-line>
                <v-list-item-avatar tile size="80" color="grey"></v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="headline mb-1">{{item.username}}</v-list-item-title>
                  <v-list-item-subtitle>{{$t('follows.card.Posts')}}: {{item.posts}}</v-list-item-subtitle>
                  <v-divider></v-divider>
                  <v-list-item-subtitle>{{$t('follows.card.Last online')}}: {{item.lastActive}}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn small color="error" @click="unfollowMessage">{{$t('follows.card.Unfollow')}}</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-if="isFollower">
          <v-col md="6" v-for="item in followers" :key="item.id">
            <v-card class="mx-auto" max-width="344" outlined>
              <v-list-item three-line>
                <v-list-item-avatar tile size="80" color="grey"></v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="headline mb-1">{{item.username}}aaaa</v-list-item-title>
                  <v-list-item-subtitle>{{$t('follows.card.Posts')}}: {{item.posts}}</v-list-item-subtitle>
                  <v-divider></v-divider>
                  <v-list-item-subtitle>{{$t('follows.card.Last online')}}: {{item.lastActive}}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn v-if="item.following == 1" small color="error" @click="unfollowMessage">{{$t('follows.card.Unfollow')}}</v-btn>
                <v-btn v-if="item.following == 2" small color="success" @click="followMessage">Følg bruker</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col md="4">
        <v-row>
          <v-col md="12" class="mt-6 ml-6">
            <p class="title" @click="isFollower = false" style="cursor: pointer;">Your <span class="primary--text"> {{$t('follows.general.Follows')}} </span> <span style="border-bottom:1px solid black;">{{following.length}}</span></p>
            <p class="title" @click="isFollower = true" style="cursor: pointer;"><span class="success--text">{{$t('follows.general.Followers')}}: </span> <span style="border-bottom:1px solid black;" >23.5k</span></p>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import messages from "./modules/lang/main/export";
import FollowsInfoDialog from "@/components/informational_dialogs/private/follows_info_dialog.vue";
export default {
  i18n: { messages },
  components:{
    FollowsInfoDialog
  },
  data(){
    return{
     isFollower: false,
      FollowsInfoDialog: false,
      following:[
        {id:1, username:"Bob", posts:10, lastActive:"2020.01.01"},
        {id:2, username:"JIll mcrena", posts:5, lastActive:"2020.01.02"},
        {id:3, username:"Kimster", posts:7, lastActive:"2020.01.01"},
        {id:4, username:"Doe joe", posts:102, lastActive:"2020.01.03"},
      ],
      followers:[
        {id:1, username: "Jack Mcrea", posts:65, lastActive:"2020.01.10", following:1},
        {id:2, username: "Julia", posts:5, lastActive:"2020.01.13", following:1},
        {id:3, username: "Rambo", posts:11, lastActive:"2020.01.12", following:2},
        {id:4, username: "Sarah hunt", posts:18, lastActive:"2020.01.15", following:1},
        {id:5, username: "Bob", posts:22, lastActive:"2020.01.11", following:2},
        {id:6, username: "Tony", posts:3, lastActive:"2020.10.01", following:2},
        {id:7, username: "Tara", posts:23, lastActive:"2020.01.09", following:1},
        {id:8, username: "Grill", posts:1, lastActive:"2020.01.19", following:2},
        {id:9, username: "Not a Grill", posts:1, lastActive:"2020.01.01", following:2},
        {id:10, username: "Doe", posts:12, lastActive:"2020.01.10", following:1},
        {id:11, username: "Jane", posts:6, lastActive:"2020.01.13", following:1},
      ]
    }
  },
  methods:{
    unfollowMessage(){
      var confirmed = confirm(
        this.$t('follows.card.You are no longer following this user')
      );
    },
    followMessage() {
      var confirmed = confirm(
        "You are now following this user"
      )
    }
  }
}
</script>